<template>
    <div id="notice_detail">
        <div class="top_title fixed">{{notice.title}}</div>
        <div class="time" v-if="notice.ctime">{{ notice.ctime.slice(0,16) }}</div>
        <div class="content" v-html="notice.content"></div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            notice: {}
        }
    },
    mounted() {
        this.getdetail()
    },
    methods: {
        getdetail() {
            this.$Ajax('message/detail',{id: this.$route.query.id},'get').then(rs => {
                if(rs.code == 200) {
                    this.notice = rs.data
                }
            })
        }
    },
}
</script>
<style lang="less" scoped>
.top_title.fixed {
  top: 7.7rem;
}
#notice_detail {
    .time {
        padding: 0.5rem;
        text-align: end;
        color: #aaa;
    }
    .content {
        padding: 1rem;
        font-size: 1.6rem;
    }
}
</style>